import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsx } from 'react/jsx-runtime';
import { documentsTypes } from '../documentsTypes/index.js';
import { DeclarationPageIcon } from './icons/DeclarationPageIcon.js';
import { IdCardIcon } from './icons/IdCardIcon.js';
import { EndorsementIcon } from './icons/EndorsementIcon.js';
import { KeyFactsIcon } from './icons/KeyFactsIcon.js';
import { DriversClubIcon } from './icons/DriversClubIcon.js';
import { BillingScheduleIcon } from './icons/BillingScheduleIcon.js';
import { PrivacyIcon } from './icons/PrivacyIcon.js';

var _a;
var documentIconsMap = (_a = {},
    _a[documentsTypes.DECLARATIONS_PAGE] = jsx(DeclarationPageIcon, {}),
    _a[documentsTypes.ID_CARD] = jsx(IdCardIcon, {}),
    _a[documentsTypes.ENDORSEMENT_COVER_LETTER] = jsx(EndorsementIcon, {}),
    _a[documentsTypes.KEY_FACTS_SHEET] = jsx(KeyFactsIcon, {}),
    _a[documentsTypes.KEY_FACTS_SHEET_2] = jsx(KeyFactsIcon, {}),
    _a[documentsTypes.KEY_FACTS_SHEET_3] = jsx(KeyFactsIcon, {}),
    _a[documentsTypes.DRIVERS_CLUB] = jsx(DriversClubIcon, {}),
    _a[documentsTypes.BILLING_SCHEDULE] = jsx(BillingScheduleIcon, {}),
    _a[documentsTypes.PRIVACY_POLICY_HAGERTY] = jsx(PrivacyIcon, {}),
    _a[documentsTypes.PRIVACY_POLICY] = jsx(PrivacyIcon, {}),
    _a);
var DocumentIcon = function (_a) {
    var documentId = _a.documentId, className = _a.className, style = _a.style;
    return (jsx("div", __assign({ className: className, style: style }, { children: documentIconsMap[documentId] })));
};

export { DocumentIcon };
